<template>
  <div class="calico-card-info-page">
    <div class="calico-card-info-container">
      <div class="calico-card-info-row">
        <div style="width: 300px;">
          <CalicoCardInfo
            label="Label"
            content="Content"
          />
        </div>

        <div style="width: 300px;">
          <CalicoCardInfo
            label="Label"
            content="Content"
            variant="muted"
          />
        </div>
        
        <div style="width: 300px;">
          <CalicoCardInfo
            label="Label"
            content="Content"
            variant="dark"
          />
        </div>
      </div>

      <div class="calico-card-info-row">
        <div style="width: 600px;">
          <CalicoCardInfo
            label="Longer Label"
            content="This is an example of a wider Info Card used to display slightly longer content."
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CalicoCardInfo from '@/components/calico/cardInfo/index.vue';

export default {
  name: 'CalicoCardInfoPage',
  components: {
    CalicoCardInfo,
  },
};
</script>

<style lang="scss">
.calico-card-info-page {
  display: flex;
  justify-content: center;
  align-items: center;

  .calico-card-info-container {
    width: 100%;
    @include stack-space($space-large);
    @include inset-space($space-large);

    .calico-card-info-row {
      @include inline-space($space-large);
      @include inset-space($space-large);
    }
  }
}
</style>
